module.exports=[
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "The only thing that stresses me out is the inconsitency between teachers. I wish that they were required to give out all their work on Mondays for that week so that we could figure out when the best time to do work for us is."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It is extremely difficult to learn a language, like spanish, over zoom calls, because we are not able to practice easily or ask many questions. I think the most difficult part is communication between teachers and students because emails do not always help when there is confusion that is hard to word in an email."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "online learning from home, isn't really helpful, at times I don't feel like I am learning "
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I think I developed slight depression."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "reduce amount of school work and increase amount of zoom calls or video meetings"
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My mental wellbeing hasn't been the best since i tend to be more of social person."
  },
  {
    "Grade": "Sophomore",
    "Category": "Socializing",
    "Picked": "X",
    "Partial Text": "it’s hard to not see any of my friends since they are a large part of my support system",
    "Quote": "it’s hard to not see any of my friends since they are a large part of my support system"
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It’s really hard when all of my teachers use multiple different online platforms. I have one teacher that uses four different platforms and so it is really hard to keep track of assignments."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Learning new content with limited support options - we need to be taught and not just given assignments"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I, personally, have been homeschooled my whole life. Next year as a freshman would be my first year in a physical school. But that experience may be lost because of COVID."
  },
  {
    "Grade": "Sophomore",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Way more stressed and not have the time to just talk to your friends and sit down and eat with them makes paying attention way harder"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am concerned about not being able to visit schools and I am also concerned that we will not be able to go to college in person but have to start at home and still pay full tuition which would be hard on my family to afford."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Schools need to understand that there are students who hate being with their families because they are toxic and their mentalities are slowly being drained. Many students including myself struggle with depression and having a teacher call or email your parent saying how you are missing class is very exhausting and makes you feel that schools don't care about your well-being."
  },
  {
    "Grade": "Senior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It has been hard reaching the end of senior year and having our graduation ceremony cancelled, because I was looking forward to it for so long. Also looking forward to college is filled with the normal excitedness, but also nervousness about how uncertain everything is"
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "The pandemic has really affected my learning. My grades have been going down and I do not do much work. I also feel like I have not really learned anything new since we have been learning from home."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Junior year is when I was planning on visiting colleges and taking SAT's, and now with all of that cancelled it makes deciding what colleges I want to apply to much harder. Also, at my school our consulars make appointments with us to help us with colleges but now those are limited to zoom meetings and they are harder to get a hold of because you cannot just simply drop into their office."
  },
  {
    "Grade": "Sophomore",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I hope that the number of emails sent will be way less. I couldn't keep track of what I was supposed to do."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I wonder if my friends will still be my real friends?"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I’m also generally concerned about how COVID will impact college acceptances."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I’m worried if we continue to do online learning students won’t learn sufficiently to proceed forward in our classes."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My math teacher keeps assigning us stuff we haven't learned about. Yall can tell him to chill with the homework"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "i think the teachers should take it a little easier on us the next school year because they have to understand it is difficult to learn a way of school then drop it and move to something completely different. i would like to go back to regular school because i have to be in a classroom to learn best"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "not stressed about standardized testing or the application process, more so about the possibility of lower acceptance rates due to more class of ‘20 kids taking a gap year and applying for fall ‘21"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Needs to be refined. Everything is hodge podged together."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I have been researching nonstop the last couple of months about different college options and scholarships available to me, but I think I am probably missing out on a lot not being able to speak with my counselor or access my school's scholarship center. It has been adding a severe amount of stress into my life."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "What's the point of even applying to college if there's no guarantee you'll actually go there? I'm not going to pay 30,000 or more dollars a year to take zoom courses. I can't work to save for college either."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "I feel stressed and disappointed with the lack of communication from teachers, my school district.",
    "Quote": "I feel stressed and disappointed with the lack of communication from teachers, my school district."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Without college tours, and knowing whether or not we will be able to take standardized tests, the outlook on applying to colleges soon seems crazy! Preparing for college using just online resources is very stressful as well, since I have no idea what to really look for or do."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "if SAT becomes optional then more emphasis is put on the gpa which if you messed up for any reason is a yikes"
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Some teachers have been expecting us to log time on canvas but don’t have any actual stuff for us to do there."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Laptops aren’t currently being distributed to anyone but high schoolers, and it’s only because of my moms job that we have enough laptops for all my siblings to use for their work. Also, many students are going to have more responsibilities like taking care of siblings now that most childcare is closed. Online schooling assumes too much to be sustainable and I’m not sure there’s any good way to fix it."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Academics have improved. Social life has decreased but there has also been a decrease in bullying. Future plans have broadened. I enjoy spending more time with my family."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "if I’m not expecting to get homework from a certain class on a certain day and I receive an email with homework then that stresses me out. Also I think that all the teachers should have the same way of taking attendance because it’s easier and kids would be less likely to get confused and be marked absent. I think teachers should also send out reminders about homework and when it’s due because some kids might’ve misunderstood directions or due dates or just completely forgotten about the assignment since kids have a lot of other things to do at home. Lastly I think that teachers need to become a little bit better at communicating."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am also anxious because I am trying to take advantage of my time in quarantine, because I believe that part of the 2021 admission process will be to judge a student based upon how well they spent their time during quarantine."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I’m not sure what colleges want in order for me to apply since the virus or if the same scholarships will be available. Many of the resources we would usually use to ask questions are incredibly busy and aren’t able to reply."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am way more stressed, I am not motivated to do like any school work"
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Lately I have been feeling sort of off and I’m trying to just get through the remaining bit of school. There is not really anything that is motivating me and the days are just passing me by."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I think that all teachers should be using turnitin.com because it is very easy for us students to use instead of navigating through a bunch of different sites to turn things in we could all have one place."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Especially for math. I don't feel that I am able to do the same stuff that I could before. I don't learn as much and I don't think I'll be ready for next year."
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I haven't felt nearly as happy or fulfilled. Again, I am always tired, can't sleep at night, it's almost every day that my stomach aches from anxiety and stress. \"What if I don't pass?\", I'll always end up asking myself. I feel like a failure half the time, looking back at how much work I could do and how well it would turn out, just to see how terrible I am at working now."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Having math is hard of me online when my teacher leaves it to kahn academy to teach us we send a couple days on it and then were on to something else, instead of taking the time to grasp the concept"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "X",
    "Partial Text": "I’ve had a relatively hard time forming lasting relationships with my freshman peers. I’m worried that I’ll have to start all over from square one again.",
    "Quote": "I’m concerned that we will have to start all over with the social dynamic. I’ve had a relatively hard time forming lasting relationships with my freshman peers. I’m worried that I’ll have to start all over from square one again."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I really appreciate the move to Canvas"
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "we need LESS work than normal, not more. everything take 3x as long to complete at home in a distracting environment without teacher help. especially for those of us with learning and attention disabilities, online school is extremely stress inducing. also more actual instruction time. not just written instruction for each assignment but instruction on the material and how to do the assignments. also examples since we can’t compare with classmates anymore"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I really struggle trying to figure out what I want to spend the rest of my life doing and what colleges are rights for me"
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Very complicated and self stress its totally has brught me more behind in school"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I'm taking Alg 2 right now, and a lot of my friends who are taking Alg 2 with me are really concerned bc we plan to take IB pre-HL next year and that's going to be more difficult. There's a lot of content in Alg 2, and I'm honestly pretty worried about readiness to take other courses next year too."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I miss my teachers, class structure and my friends."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I’m concerned about retaking SAT’s, and the effects that will have on college applications."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "How make friends as a ninth grader"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "X",
    "Partial Text": "have no idea where to start w college essays,",
    "Quote": "I feel like I have no idea where to start w college essays, which I probably would have gotten some help from the school about"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "X",
    "Partial Text": "I feel stressed on the entire college applications process.",
    "Quote": "I feel stressed on the entire college applications process. I am unsure on how to ask teachers to write college aps for me."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "At first I was happy to be out of school but now being at home is driving me crazy and I just want a break from my family."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "school has not taught me everything I should know to be prepared for the subjects I will be taking next year.",
    "Quote": "I feel like the school has not taught me everything I should know in order to be prepared for the subjects I will be taking next year."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "X",
    "Partial Text": "As a student with ADHD, it's been a struggle absorbing information, remembering class schedules, and motivating to do all my work.",
    "Quote": "As a student with ADHD, it's been a struggle absorbing information, remembering class schedules, and motivating to do all my work. It feels like kind of a dark time, and school has honestly been at the back of my mind for most of this closure. It has really taken a toll on mine and a lot of kids mental health to not be able to see our friends for support or attend any events we might have been looking forward to. Personally, I kind of wish the district had taken this time to improve next year's curriculum and give students some much needed rest and self-care time while we experience this collective trauma."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Very stressed with upcoming standardized testing, not sure what to do about scholarships or really how to do college stuff cause they canceled meetings with counselors on college advice"
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I miss going to school and playing sports. I miss seeing my friends and life being normal. I was really sad, tired, and lazy. It felt like I had given up for a period of time."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "For video meetings, microsoft teams is massively ineffective. I understand the security concerns, but it's about as secure as Zoom. I think that organizing some semblance of in person interaction as a part of learning is also very important-- if in person classes are not possible, then maybe organizing small group study sessions."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I understand everyone needs recommendation letters and certain forms but we weren’t there to be taught how to collect the items or how to write entrance essays. I’m really overwhelmed and not really knowing where to start for college."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "",
    "Quote": "My biggest concern is math next year. I am having a hard time understanding concepts fully from online school."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I havent been able to hang out with friends or play sports and I've been sleeping in and staying up late which usually leads to me not being productive so I procrastinate"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I guess I’m dissapointed that I won't experience all the fun events that go on at the end of the year."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It would be very helpful if teachers were actually allowed to lecture new content over zoom and not just stick to answering questions. And that thing where teachers had to assign 45 minutes of work per day? And they had to put in a certain number of grades? What are the purposes of that? I felt like there were ideas of not giving students too much work, but also giving students work; the methods of achieving it seemed to clash. And then there is also the question of \"will we be going to school physically at all next year.\" I know that some classes have been fine-- but I feel like it was mainly because a majority of the year has already happened. How is pottery class and computer science class and robotics class and weight training class going to work next year? I would love to go in for at least part-time for those classes."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "since I have to learn the material by myself and then do the work, I've been spending significantly more time doing schoolwork at home than I would be if school was normal. a six hour work day has turned into an eight or nine hour one."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "one of the problems I've encountered most is not being able to find a quiet, distraction-free environment that I can really focus and learn in."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "How will I meet the expectations of my sophomore classes when I haven't mastered my freshman content? I was excited about the courses I selected, but now I feel anxious and scared.",
    "Quote": "How will I meet the expectations of my sophomore classes when I haven't mastered my freshman content? I was excited about the courses I selected, but now I feel anxious and scared."
  },
  {
    "Grade": "Sophomore",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It’s a lot more unstable because I can’t predict anything and can’t find comfort in planning for the future. I haven’t been able to rely on my friends or see them as much and there isn’t much that excites me while I’m stuck at home"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I feel like we don’t have enough guidance from our counselors right now during this time"
  },
  {
    "Grade": "Senior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "culture shift to have more student voice and to have a more active ASB and to make sure we re-look at all of our systems that we already have in place to see what is working and what is not working. We need to do more surveys through the year for students, staff and the community to give them voice and be part of the decision making."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I'm very nervous about the upcoming college application process and I don't think that I'm good enough to get into the colleges I like."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It kind of affects sports, which brings people together,"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I feel like I am behind in my classes because I didn’t really understand a most of the online lessons"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Google classroom and zoom"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "X",
    "Partial Text": "I'm afraid there won't be social events such as football games, retreats, and or dances for me to make friends going into high school.",
    "Quote": "I do want everyone to be safe and healthy, but gong into freshman year, I'm afraid there won't be social events such as football games, retreats, and or dances for me to make friends going into high school."
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am sad and lonely because I can’t see most of my friends, and online communication and video calls aren’t the same."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am stressed about how well I will do on the standardized testing and if I should even put it in my application"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I feel that missing out on a quality education for the rest of the school year will harm my testing scores and my changes of getting into college."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My way of learning does not fit with the virtual learning whatsoever so it has taken a toll on my grades and motivation"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "We have not learned anything about the application process for colleges"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "School is not only about the academics but also learning valuable social skills and interacting with my friends. In school classroom instruction is also crucial when introducing new curriculum"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "One thing i’m afraid of is that the teachers aren’t going to be prepared for how many of us never got the full learning aspect of a certain class, so not all of us are on the same page going into the next school year!"
  },
  {
    "Grade": "Senior",
    "Category": "Mental Health",
    "Picked": "X",
    "Partial Text": "I have ADHD, which makes working from home (both before and during the pandemic) very hard.",
    "Quote": "I have ADHD, which makes working from home (both before and during the pandemic) very hard. There's only so much that can be done about that, but it's worth mentioning."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I recently moved here and adjusting has been quite difficult now with quarantine it provides new challenges making it even harder to adjust the homework is difficult to finish and interacting with teachers is a challenge on its own we do not have live lectures and everything is based off of self learning"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "",
    "Quote": "Online learning has been far inferior to in person school. I plan on taking advanced classes next year and feel pretty underprepared. I also have some AP classes next year and and am scared that I won’t be able to lead the required material in an all online system."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I'm taking algebra 2 this year, and pre calc next year. I'm worried that will be hard for me because I missed stuff this year."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "it can be very difficult trying to focus at home and. not having peers to help, or someone there to ask questions.",
    "Quote": "I have been participating in some of the online work, but it can be very difficult trying to focus at home and. not having peers to help, or someone there to ask questions. it also has been very sad knowing some people I may not see again. some friends I didn't quiet recognize were close friends until I didn't see them anymore."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "so much stress. without having access to teachers and school councilors for day to day help it’s hard to keep up with all that. especially since we’ve been getting more school work with no instruction now than we ever did before COVID"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I want to take the SAT in order to have a score to submit to colleges, but I'm unsure if I'll be able to in time for early applications."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "For classes that have knowledge that carries on to next year, I am concerned, because I don’t think I got enough out of the courses to be able to do well next year.",
    "Quote": "For classes that have knowledge that carries on to next year, I am concerned, because I don’t think I got enough out of the courses to be able to do well next year."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I do have the concern that i will not be as prepared and academically prepared as i should have been for next year"
  },
  {
    "Grade": "Junior",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am also feeling very stressed as far as being a student athlete in college because a lot of our last summer season is being taken away."
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It’s hard to do work when you know people are dying and the world isn’t doing good. It’s hard not learning in a classroom. I like to be taught in person"
  },
  {
    "Grade": "Junior",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "i feel like I'm missing out on what would've been the best part of junior year, and possibly my high school career. I miss my friends and it's becoming increasingly difficult to maintain a work-life balance when the only thing separating school from home is whether I'm sitting at the dining room table."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It has gone from being ambitious to letting go of some of my goals"
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Had an impact on social life, depressing my mood. Also, has created family tensions which also affect my mood."
  },
  {
    "Grade": "Senior",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "teachers should be more lenient and understand that the amount I can learn in school greatly differs from the amount I can learn at home.",
    "Quote": "It is really hard for me to do school work at home, I think teachers should be more lenient and understand that the amount I can learn in school greatly differs from the amount I can learn at home."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Maybe having all classes be on the same platform, not of differnt ones because as a student, it is hard to be working on 3 different types of platforms. It would be nice to have them all in one spot."
  },
  {
    "Grade": "Senior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I have severe ADHD, and it becomes incredible hard to accomplish even simple tasks for my teachers. Mostly because I have so many distractions at home."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "School was a distraction to a lot and now I don’t have that safe place"
  },
  {
    "Grade": "Junior",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "my junior baseball season which is the most important when it comes to recruiting got cancelled."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "X",
    "Partial Text": "Everything feels like things are piling up and there's not mental help support available.",
    "Quote": "Everything feels like things are piling up and there's not mental help support available."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Only one of my teachers out of the 7 classes I have are offering weekly Zoom meetings, and I find virtual in-person learning much more helpful than emailing questions."
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "X",
    "Partial Text": "it is extremely difficult to concentrate when you live with so many people in such a close space",
    "Quote": "Some universities are still requiring test scores and it is extremely difficult to concentrate when you live with so many people in such a close space and also worrying about finances with your family."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Counselors should actually check on kids with mental health problems"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "online school assumes that I have the technology I need, that I know how to do all the work, and that I don't need any teacher help. All of that was at times not true and made it really hard to do school work",
    "Quote": "online school assumes that I have the technology I need, that I know how to do all the work, and that I don't need any teacher help. All of that was at times not true and made it really hard to do school work. The most important improvement I would have is to have students either in the classroom as much as possible and have live virtual teaching at all times when not in the classroom."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Everything should be on teams"
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "all assignments and communications IN ONE PLACE!! I have to go on outlook, word, teams, blackboard, etc etc."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "For me personally, I would’ve liked more zoom meetings and emails. I hardly talked to any teachers."
  },
  {
    "Grade": "Senior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Teachers being more understanding is a must. This is all hard for everyone and people just need to give some grace."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I have became unmotivated to do school. I have not kept in touch with any of my friends."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "X",
    "Partial Text": "How am I supposed to get that bonding time to meet my fellow classmates?",
    "Quote": "I have had some great relationships with my teachers in the past, and I know that I will not get that connection with another human being over a computer screen. Also, my peers. How am I supposed to get that bonding time to meet my fellow classmates? I won't get the help, care, and support that is necessary from my classmates through online schooling."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "With the stay-at-home order, I can't do normal things that I would put on my college apps, like volunteering, clubs, sports, or working."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "All teachers using Google Classroom because it it easy to use."
  },
  {
    "Grade": "Sophomore",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "it has made learning a lot more difficult and not being able to see friends has negatively impacted my daily mood"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Seeing your friends and friendly faces throughout the school day creates a good work life balance. With already so much structural lack in the online schooling system, taking this social aspect away makes it even harder. There also isn’t an easy way to communicate with peers and work together to solve problems, complete work, or to ask questions/get clarification. With online learning I’m finding it hard to absorb all of the content, and with building subjects such as math and history I’m worried about how it will affect my success in future courses especially as I’m enrolled for IB diploma."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It would be nice if all teachers used the same platform"
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Umm if we're still gonna start the next school year with some form of remote learning I'd appreciate if the remote class time was used to actually TEACH LESSONS rather than just tell us what self-learning to do lol (only possible if we had a normal schedule as opposed to 2 classes a day, only having 1 class once a week)"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "i think that the teachers should reach out more i'm pretty sure they have our phone numbers and are able to reach out because i don't check my gmail all the time witch is my fault but because of this i miss my zooms and due dates for assignments."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "there's so much that I was supposed to do this year to get ready for what I was doing after highschool"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "For me some of the most important things are if sports are going to opened back up before the start of next school season."
  },
  {
    "Grade": "Senior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Teachers have to be conscious of how exhausting online education can be even without the addition of homework. Assignments and homework can not have the same scheduling practices as before remote learning."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I find it harder to work from home because of the absence of my teachers, and I have many things that I'd rather do at home so it kind of takes away from my school work."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "all teachers on the same page about how much work can be assigned"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "x",
    "Partial Text": "",
    "Quote": "I feel like we didn't learn as much from online school as we would if we were in a classroom."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My school is using teams as the main platform to have video classes and personally I think zoom is much better as you are able to see everyone at the same time, which promotes engagement, as well as being able to use breakout rooms"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "The platforms should change. I have 1/3rd of my teachers using an app called Edpuzzle, 1/3 using google classroom and 1/3 using zoom and it’s hard to do it all + teachers post assignments at 12 am at midnight so it harder to know that we have an assignment posted"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I haven't been able to take my ACT yet and will have to take it in August at the earliest! I also don't want my college experience to be completely digital."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I'm also the first generation to experience the college admissions process as a domestic student, so I'm afraid I would have trouble going through the applications."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am worried that I won't have enough practice and experience with class discussions and debates. I am also worried that the overall high school experience along with the learning has and will be compromised."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "mostly pressure from my parents but also concerned because I was in a bad position with my grades before we got out of school and now I don't even know where to start to try to fix it."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I'm worried about not being ready for next year's Honors classes and losing the friendships I have made."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "A lot of people in my class have just found their friend groups and some still are."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "honestly less homework and having teachers be aware of how much this sucks would be great"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "X",
    "Partial Text": "It very much felt like I was just getting on my feet, socially, when the quarantine began.",
    "Quote": "It very much felt like I was just getting on my feet, socially, when the quarantine began. I’m also more than a little worried about how the ongoing-curriculum classes will function, ie math and sciences."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "There needs to be actual teaching instruction time even if it is online instead of just posted assignments that students do independently."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My mental state has gone off the rail a bit and by a bit I mean a lot"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am concerned that I won’t be ready for Algebra 2 Honors. I am taking Geometry currently, and it is very difficult to learn these new concepts via online learning because I learn best in a classroom. The same goes for Spanish 3, which I will also take next year. A big part of Spanish is being able to practice it orally, so it is difficult to learn the concepts that I am currently being taught in Spanish 2 during this time. In regards to social dynamics, I am worried that I won’t be able to see my friends and make new friends if we don’t go back to school. A big part of school to me is the social aspect, and if we can’t go back to school in the fall then my eagerness to learn will likely be diminished."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I miss everything and I feel like I have lost a bond with my some of my friends. I overthink a lot naturally and the fact that there is more freetime makes me think a lot. I have family issues going on right now that is putting me in a dark spot right now and i am a little stressed with that and planning next year out. It is hard to plan them because I have no idea if it really going to happen or not. At least one a day I feel overwhelmed with everything."
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am also growing very tired of being with my family 24/7 and overall lacking motivation to do work for school"
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It would help a lot if all teachers were required to communicate through one platform. The district encourages using Canvas, but I have several teachers who continue to use email, Google Classroom, or their district website because they don't want to learn to use a new platform."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Online school made me not want to work as hard as I do in public school."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "We should have everything in one place. For all classes."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "X",
    "Partial Text": "I have no motivation to complete my school work and it is extremely easy to fall behind",
    "Quote": "I have no motivation to complete my school work and it is extremely easy to fall behind"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My school postponed, then cancelled SAT testing this year. They say that there will be another free SAT in September but I'm very worried we won't be back and able to take it like normal by then."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It will be difficult to continue to make friends and fit in to Social groups if we aren’t in person."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I really miss talking to people an I find my self being super bored."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Sending out more remind texts to notify us when assignments are due!"
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I miss my friends, my teachers, etc. School is a place I go to forget about home and to learn and grow. Online is horrible and is a joke. It is seriously depressing and isolating to stare at a screen all day."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "even though colleges say that they're not requiring it, i know that a good score will bring me an advantage."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I feel like counselors, since I cannot talk to them in person, are more difficult to talk to, and that means that any questions about college applications are more difficult to get complete answers about. Also, standardized testing, or rather, the standardized testing I did recently, was more difficult than I expected."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I worry that I won't be able to show my best test scores and abilities to colleges."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My parents are pressuring me to go to college and to come up with a plan if what I want to do for a career but I have no clue."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I hate zoom so much"
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "No Microsoft teams, it sucks"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I’m just worried about my GPA affecting what colleges I can go to."
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I took Chemistry this year and plan on taking Chem 3/4 next year and I don't think I'm prepared. I haven't learned at the same pace in social distancing for this class and I'm still so confused on certain topics"
  },
  {
    "Grade": "Junior",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I have missed out on having a social life."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "X",
    "Partial Text": "Keep it simple and try to have everything on 1 or 2 different platforms so I dont have to sign up to a bunch of websites to do my work",
    "Quote": "Keep it simple and try to have everything on 1 or 2 different platforms so I dont have to sign up to a bunch of websites to do my work"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I feel unprepared for algebra 2 trig and the second year of learning asl"
  },
  {
    "Grade": "Freshmen",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "This year, I took Geometry, but next year I've got to start Trig. My teacher has given up on Geo, and is just teaching us more Trig so maybe we'll have a head start next year."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "As an incoming freshman I am worried about how to fit into the school culture. This is a concern that I already have but I am especially worried about this if we are doing school from home."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "have 1 on 1 tutoring for the students that struggle."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "There is currently zero support or information regarding the college application process. I also don’t know if the college app process is likely to change because of our situation."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "open counseling zooms at all times. councilors are never available during school and especially not now they are very difficult to talk to at any time without burdening my own schedule."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "everything is stressful already before any of this happened but adding on the fact that there's a pandemic, most of us have no clue what we're going to do after high school and our parents yelling at us for our grades. its been extremely stressful and wondering how this is going to impact our future"
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "",
    "Partial Text": "",
    "Quote": "english is not my first languega, i am also very confused about the whole process of college applications, and to add up i am more like a visual learner which means i will need an instructor or something like a guidance. i am also not very good at testing and i don't have any information about sources that can help me study."
  },
  {
    "Grade": "Junior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "The only thing that stresses me is my little brothers. I have a lot of siblings and i have to watch them all the time because my parents work, it’s hard to do work if I’m watching them. My grades are pretty bad but I guess that’s okay. I’ll just try to improve them next year. I don’t think my teachers understand how hard it is."
  },
  {
    "Grade": "Junior",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "High school is a highly social time, and collaboration through team sports is also vitally important. All these things are missing"
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "X",
    "Partial Text": "With everything going on right now with the covid-19 or the protest for blm it can be hard to want to sit and right an essay on Antigone.",
    "Quote": "I think we just need to remember that theres so much going on in the world right now that it can sometimes be hard to focus of school. With everything going on right now with the covid-19 or the protest for blm it can be hard to want to sit and right an essay on Antigone. I don't know what the futures going to look like but all I know is we are apart of it, and personally I'd rathe be talking about what's going on right now than a play written in 441 B.C."
  },
  {
    "Grade": "Sophomore",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "post most things in google classroom and not skyward"
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I also have trouble with people normally so I'm worried about having to suddenly talk to lots of people or have to talk about what we did during quarantine."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I think all teachers should have the same way of taking attendance because kids won’t get confused as much or be marked absent on accident. I also think that all zooms should be made optional because of internet issues. I have had many incidents where I try to log onto my zooms in the morning but my WiFi is having problems and I get marked tardy or absent because I couldn’t get into the zoom meetings. I know that this situation has occurred in other students lives too and I hope that it’s something we can fix."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Teacher communication is fine with some classes, but with others I haven’t heard from teachers at all."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "X",
    "Partial Text": "its harder to find materials to help us get ready for the SAT and AP tests bc you don't have someone to help guide you and someone whom you can talk to in person for help. instead, we have to rely on emails that can take longer than expected to receive a reply and online work that has been posted.",
    "Quote": "With the lockdown, it feels like its harder to find materials to help us get ready for the SAT and AP tests bc you don't have someone to help guide you and someone whom you can talk to in person for help. instead, we have to rely on emails that can take longer than expected to receive a reply and online work that has been posted. We are also limited to our zooms and youtube for help as we cant simply talk to our teacher for help."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I had tons and tons of homework and I felt like I was never going to get it all done on time. It might’ve been because I was studying for my AP test nonstop but I still felt like I was drowning in homework. I finally have been able to feel more relaxed these past few weeks as my teachers start to assign less homework towards the end of the school year. I’m actually able to take time for myself to do the things that I enjoy which I felt like everyone else had already been doing during quarantine."
  },
  {
    "Grade": "Freshmen",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I am unsure if the remote learning in some classes is going to be enough to prepare for next year, and I feel like I missed a big opportunity to make connections because spring soccer was cancelled."
  },
  {
    "Grade": "Junior",
    "Category": "College",
    "Picked": "X",
    "Partial Text": "Even though we have all of the internet at our fingertips I feel very lost and not very supported.",
    "Quote": "Even though we have all of the internet at our fingertips I feel very lost and not very supported. Trying to balance looking at all the information with trying to get schoolwork done is very difficult."
  },
  {
    "Grade": "Senior",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "For the people who can’t focus (like me) they should have a space where we can go work with WiFi."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "It’s gotten worse, I have no routine and my motivation has really gone downhill."
  },
  {
    "Grade": "Junior",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "my teachers have gone weeks without reaching out or letting students know what we should be doing."
  },
  {
    "Grade": "Sophomore",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "have been very stress because its just so hard to stay motivated during this time and if i don't get my work done the i wont get points so i try really hard to do it half the time i start crying during it haha"
  },
  {
    "Grade": "",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Hanging out with my friends. I think that has a huge impact on how people’s health are emotionally and mentally. I don’t need to hang out with a lot of people, but even just a few would be nice. It’s been a long time and friends are a huge part of a persons life."
  },
  {
    "Grade": "",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I've completely broken down and stopped caring about almost anything"
  },
  {
    "Grade": "",
    "Category": "Socializing",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Being in high school the interactions you get with friends during school, and extracurriculars after school, shape a lot of your high school memories and are what make your day more positive-- online learning meanwhile makes it feel like they're not really there"
  },
  {
    "Grade": "",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "The isolation triggered a major depressive episode, and other mental health issues started after that. That may be unrelated."
  },
  {
    "Grade": "",
    "Category": "Online Learning",
    "Picked": "",
    "Partial Text": "",
    "Quote": "I think we could pull off online schooling but there needs to be decisive action and clear instructions, as well as more laptop and hot spot distribution."
  },
  {
    "Grade": "",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "Stress and depression have been a huge change in my mental wellbeing."
  },
  {
    "Grade": "",
    "Category": "Mental Health",
    "Picked": "",
    "Partial Text": "",
    "Quote": "My emotional and mental wellbeing has gone down the drain. I am constantly stressed with what is yet to come, the harder courses I have signed myself up for next fall, my dance studios performances being pushed back by months, the uncertainty, the fact that this is not in my control because I am a control freak, not being able to see my friends and communicate with people other than my immediate family members"
  }
]